import { CareerPath } from '@backrs_ui/common-ui';

import { ProfileValueOption, ProfileFields } from '@backrs_ui/grow-ui/src/redux/profile/profile';

import { ResolverFunction } from './resolvers.config';
import { FieldConfig, ProfilePageConfig } from '../types/profile.types';
import { createFieldConfig } from '../utils/fields.helpers';
import { mapStandardProfileArrayValues } from '../utils/resolvers.helpers';

export const CAREER_FIELD_CONFIGS: Partial<FieldConfig> = {
  careerPaths: createFieldConfig({
    key: 'careerPaths',
    type: { variant: 'AUTOCOMPLETE', manualFilterOptions: true },
    chipType: 'tag',
    showSearch: true,
    placeholder: 'Search Career Paths',
  }),
  careerExperiences: createFieldConfig({
    key: 'careerExperiences',
    type: { variant: 'CHECKBOX_GROUP' },
  }),
  careerOccupation: createFieldConfig({
    key: 'careerOccupation',
    type: { variant: 'TEXT' },
    placeholder: 'Your current role',
  }),
  careerEmployer: createFieldConfig({
    key: 'careerEmployer',
    type: {
      variant: 'API_AUTOCOMPLETE',
      autoCompleteEndpoint: '/profile/lookups/employers',
      displayProperty: 'employer',
    },
    chipType: 'tag',
    showSearch: true,
    placeholder: 'Search Employers',
  }),
};

export const CAREER_PAGE_CONFIG: ProfilePageConfig = {
  title: 'Career Aspirations',
  description: 'Update your career details here.',
  sections: [
    {
      title: 'Occupation',
      keys: ['careerOccupation'],
      description: 'This will be displayed on your profile.',
    },
    {
      title: 'Current Employer',
      keys: ['careerEmployer'],
    },
    {
      title: 'Career Paths',
      keys: ['careerPaths'],
    },
    {
      title: 'Career Experiences',
      keys: ['careerExperiences'],
      description: 'Select any that apply to you.',
    },
  ],
};

export const CAREER_HELPERS: Partial<
  Record<ProfileFields, ResolverFunction<string | number | ProfileValueOption | CareerPath>>
> = {
  careerPaths: (profile, options) =>
    mapStandardProfileArrayValues(profile.profile.careerPaths, options.careerPaths),
  careerExperiences: (profile, options) =>
    mapStandardProfileArrayValues(profile.profile.careerExperiences, options.careerExperiences),
  careerOccupation: (profile) => {
    const occupation = profile.profile.careerOccupation;

    return occupation ? [occupation] : [];
  },
  careerEmployer: (profile) => (profile.profile.careerEmployer ?? []).filter(Boolean),
};
